import { useEffect, useRef } from 'react';
import {
	Box,
	Dialog,
	DialogContent,
	Grid2,
	IconButton,
	Typography,
} from '@mui/material';
import { CloseIcon } from '../assets/icons/Icons';
import { ChatData } from '../types';
import ChatRow from './ChatRow';
import { dateFormatter } from '../Utils/Helpers';

interface ChatWindowProps {
	isChatView: boolean;
	chatData: { [index: string]: Array<ChatData> };
}

interface ChatPopupProps {
	isModalOpen: boolean;
	data: { [index: string]: Array<ChatData> };
	onClose: () => void;
	popupTitle: string;
	isChatView: boolean;
}

function ChatBodyWindow({ isChatView, chatData }: ChatWindowProps) {
	const messagesEndRef = useRef<HTMLDivElement | null>(null); // Ref for the bottom of the chat container

	useEffect(() => {
		if (messagesEndRef.current) {
			messagesEndRef.current.style.scrollBehavior = 'auto';

			messagesEndRef.current.scrollTop =
				messagesEndRef.current.scrollHeight;

			setTimeout(() => {
				if (messagesEndRef.current) {
					messagesEndRef.current.style.scrollBehavior = 'smooth';
				}
			}, 100);
		}
	}, [chatData]);

	if (isChatView) {
		return (
			<Box
				ref={messagesEndRef}
				sx={{
					overflowY: 'auto',
					height: '75vh',
					width: '100%',
					'&::-webkit-scrollbar': {
						display: 'none', // Hide the scrollbar for WebKit browsers (Chrome, Safari, Edge, etc.)
					},
					'&-ms-overflow-style:': {
						display: 'none', // Hide the scrollbar for IE
					},
				}}>
				<Grid2 padding={'10px'}>
					{Object.keys(chatData).map((item, index) => {
						return (
							<Grid2 key={index}>
								<Typography
									variant="body2"
									fontWeight={'500'}
									textAlign={'center'}>
									{dateFormatter(item)}
								</Typography>
								{chatData[item].map((chat, value) => {
									return (
										<ChatRow
											key={value}
											position={
												chat.type === 'human'
													? 'left'
													: 'right'
											}
											text={chat.text}
											chatTime={chat.time}
											chatOwner={chat.type}
										/>
									);
								})}
							</Grid2>
						);
					})}
				</Grid2>
			</Box>
		);
	} else {
		return (
			<Grid2
				container
				width={'100%'}
				height={'70vh'}
				justifyContent={'center'}
				alignItems={'center'}>
				<Typography fontSize={'16px'} fontWeight={'400'}>
					No chat data available
				</Typography>
			</Grid2>
		);
	}
}

function ChatPopup({
	isModalOpen,
	onClose,
	data,
	popupTitle,
	isChatView,
}: ChatPopupProps) {
	return (
		<>
			<Dialog
				open={isModalOpen}
				fullWidth
				maxWidth="md"
				onClose={onClose}
				scroll="body">
				<DialogContent style={{ padding: '0px 0px 20px 0px' }}>
					<Grid2
						container
						sx={{ boxShadow: 3 }}
						padding={'10px'}
						flexDirection={'row'}
						justifyContent={'space-between'}
						alignItems={'center'}>
						<Typography fontWeight={'600'}>{popupTitle}</Typography>
						<IconButton style={{ padding: '0' }} onClick={onClose}>
							<CloseIcon />
						</IconButton>
					</Grid2>
					<Grid2 container padding={'10px'}>
						<ChatBodyWindow
							isChatView={isChatView}
							chatData={data}
						/>
					</Grid2>
				</DialogContent>
			</Dialog>
		</>
	);
}

export default ChatPopup;
